import { useEffect } from "react";

/**
 * useOutsideClick
 * Closes when clicking outside ALL given refs.
 *
 * @param {Array<React.RefObject>} refs - array of refs to exclude
 * @param {Function} onClose - callback when outside click happens
 */
export default function useOutsideClick(refs, onClose) {
  useEffect(() => {
    function handleClickOutside(event) {
      // If every ref does NOT contain the click → outside
      if (refs.every(ref => ref.current && !ref.current.contains(event.target))) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, onClose]);
}
